import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AppConfig {
  constructor() {}

  logs = environment.apiUrl + 'audit-log/';

  logsTable = {
    search: this.logs + 'search',
    booking: this.logs + 'search-booking',
    myList: this.logs + 'search-mylist'
  };

    tokenUrl = environment.apiUrl + 'oauth/v2/refresh/';
    // refreshTokenUrl = environment.apiUrl + 'token/refresh';
}
